import { InstallationPriceSimulationAssetRequest } from '@modules/installation-price-simulation/infrastructure/installation-price-simulation-request.types'

type AssetLike = { id?: string; amount?: number | string; [k: string]: unknown }
type AssetsInput = Record<string, AssetLike> | AssetLike[] | null | undefined

export function sanitizeAssets(
  assets: AssetsInput
): InstallationPriceSimulationAssetRequest[] {
  const list = Array.isArray(assets) ? assets : Object.values(assets || {})
  return list
    .filter((asset) => Number(asset?.amount) > 0)
    .map(({ id, amount }) => ({ id: String(id), amount: Number(amount) }))
}
